import { isArrayLike } from "mobx";

export function nullAndLengthCheckArray(arr) {
    if (isArrayLike(arr)) {
        return arr.length > 0;
    }

    return false;
}